import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { VendorsRouteNames } from '../../enums/router-names';
import { VendorsRoutePathNames } from '../../enums/url-paths';

const List = () => import('./List.vue');

export const listRoute: RouteRecordRaw = {
  path: buildChildURL(VendorsRoutePathNames.LIST),
  name: VendorsRouteNames.VENDORS_LIST,
  component: List,
};
